/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!!!!!!!!!!!!!!!!! README !!!!!!!!!!!!!!!!!!
 * If you make changes to this file or any other
 * lazy rendering-related file, please be sure
 * to manually test the bulk tags display with
 * enough tags to trigger multiple pages.
 * That means > 250 tags or temporarily change
 * the page size to test that multiple pages are
 * rendered correctly.
 *
 * You also may want to run the lazy_render_spec
 * locally and ensure that it passes.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
import * as React from 'react';
import RowShroud from './row_shroud';

interface RowPageProps {
  renderRows: () => JSX.Element[];
  pageSize?: number;
  rowHeight?: number;
  isInitialPage?: boolean;
}

const defaultPageSize = 250;
// see clubhouse bug 556
// https://app.clubhouse.io/brandfolder/story/556/bulk-tags-max-out-at-40-pages-no-matter-page-size
const maxPageCount = 40;

const defaultProps: Partial<RowPageProps> = {
  pageSize: defaultPageSize,
  rowHeight: 71,
  isInitialPage: false
};

export function getPageSize(entriesLength: number): number {
  return Math.max(defaultPageSize, entriesLength / maxPageCount);
}

export function getNumPages(pageSize: number, entriesLength: number): number {
  return Math.ceil(entriesLength / parseFloat(pageSize.toString()));
}

export function getPageSlice<T>(pageIndex: number, pageSize: number, toSlice: T[]): T[] {
  const startingRowIndex = pageIndex * pageSize;
  return toSlice.slice(startingRowIndex, startingRowIndex + pageSize);
}

export const RowPage = (initialProps: RowPageProps): JSX.Element | JSX.Element[] => {
  const [isRendered, setIsRendered] = React.useState(false);

  const props: RowPageProps = {
    ...defaultProps,
    ...initialProps
  };

  return isRendered || props.isInitialPage
    ? props.renderRows()
    : (
      <RowShroud
        onShown={(): void => setIsRendered(true)}
        pageSize={props.pageSize}
        rowHeight={props.rowHeight}
      />
    );
};
